import {css} from '@emotion/react';
import styled from '@emotion/styled';

type Props = {
  width?: string;
  height?: string;
};

export const Wrapper = styled.div<Props>(
  ({width = 'auto', height = 'auto'}) => css`
    width: ${width};
    height: ${height};
  `
);
